/* Ajusta SOLO el tamano del boton de Releasit en la ficha (no el flotante, que se deja
   intacto): de la pildora gruesa y angosta que trae por defecto a una barra larga y
   delgada, ancho completo del contenedor. El color ya viene bien por defecto — no se
   toca — solo el tamano.

   Por que hace falta JavaScript y no basta con CSS: Releasit escribe sus estilos en el
   atributo style del elemento y ademas con !important. Un inline !important gana a
   cualquier regla de hoja de estilos, asi que la unica forma de sobreescribirlo es
   volver a escribir el inline con setProperty(..., 'important'). Mismo mecanismo ya
   probado en lv-boton.js (Liver Support). */
(function () {
  if (window.__baBotonTam) return;
  window.__baBotonTam = 1;

  var ESTILOS = {
    'width': '100%',
    'max-width': '100%',
    'min-height': '0',
    'height': 'auto',
    'padding': '15px 18px',
    'border-radius': '10px',
    'margin': '0',
  };

  function pinta(el) {
    if (!el) return;
    el.dataset.baTam = '1';
    for (var k in ESTILOS) el.style.setProperty(k, ESTILOS[k], 'important');
  }

  function buscar() {
    var todos = document.querySelectorAll('#_rsi-buy-now-button, [id*="rsi-buy-now"]');
    for (var i = 0; i < todos.length; i++) {
      var e = todos[i];
      // El boton flotante se deja tal cual: solo se achica el de la ficha.
      if (getComputedStyle(e).position === 'fixed') continue;
      if (e.closest && e.closest('._rsi-buy-now-button-floating')) continue;
      pinta(e);
      vigila(e);
    }
  }

  function vigila(el) {
    if (el.__baObs) return;
    el.__baObs = 1;
    new MutationObserver(function () {
      if (el.style.getPropertyValue('width') !== '100%') pinta(el);
    }).observe(el, { attributes: true, attributeFilter: ['style'] });
  }

  var intentos = 0;
  var t = setInterval(function () {
    buscar();
    if (++intentos > 40) clearInterval(t);
  }, 250);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', buscar);
  } else {
    buscar();
  }
})();
